import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Button } from '../ui/button';
import { Plus, X } from 'lucide-react';

export const KeyTakeawaysCard = ({ formData, onChange }) => {
  const [value, setValue] = useState('');
  const handleAdd = () => {
    if (value.trim()) {
      onChange('key_takeaways', [...formData.key_takeaways, value.trim()]);
      setValue('');
    }
  };
  return (
    <Card>
      <CardHeader><CardTitle>Principais Pontos</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div className="flex gap-2">
          <Input value={value} onChange={(e) => setValue(e.target.value)} placeholder="Adicionar ponto principal" onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), handleAdd())} />
          <Button type="button" variant="outline" onClick={handleAdd}><Plus className="w-4 h-4" /></Button>
        </div>
        <ul className="space-y-2">
          {formData.key_takeaways.map((takeaway, index) => (
            <li key={index} className="flex items-start gap-2 bg-slate-50 p-3 rounded-lg">
              <span className="flex-1">{takeaway}</span>
              <button type="button" onClick={() => onChange('key_takeaways', formData.key_takeaways.filter((_, i) => i !== index))} className="text-slate-400 hover:text-red-500">
                <X className="w-4 h-4" />
              </button>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export const FAQCard = ({ formData, onChange }) => {
  const [newFaq, setNewFaq] = useState({ question: '', answer: '' });
  const handleAdd = () => {
    if (newFaq.question.trim() && newFaq.answer.trim()) {
      onChange('faq_items', [...formData.faq_items, { ...newFaq }]);
      setNewFaq({ question: '', answer: '' });
    }
  };
  return (
    <Card>
      <CardHeader><CardTitle>Perguntas Frequentes (FAQ)</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3 p-4 bg-slate-50 rounded-lg">
          <Input value={newFaq.question} onChange={(e) => setNewFaq({ ...newFaq, question: e.target.value })} placeholder="Pergunta" />
          <Textarea value={newFaq.answer} onChange={(e) => setNewFaq({ ...newFaq, answer: e.target.value })} placeholder="Resposta" rows={2} />
          <Button type="button" variant="outline" onClick={handleAdd} className="w-full">
            <Plus className="w-4 h-4 mr-2" />
            Adicionar FAQ
          </Button>
        </div>
        <div className="space-y-3">
          {formData.faq_items.map((faq, index) => (
            <div key={index} className="bg-white border border-slate-200 p-4 rounded-lg">
              <div className="flex items-start justify-between gap-2">
                <div>
                  <p className="font-medium text-slate-900">{faq.question}</p>
                  <p className="text-slate-600 text-sm mt-1">{faq.answer}</p>
                </div>
                <button type="button" onClick={() => onChange('faq_items', formData.faq_items.filter((_, i) => i !== index))} className="text-slate-400 hover:text-red-500">
                  <X className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
